import React, { useEffect, useState } from 'react'
import { RoleHierarchy } from '../../../../shared/src/data/roleHierarchy/roleHierarchy'
import { ScanDetails } from '../../../../shared/src/data/scanDetails'
import { Box, createStyles, makeStyles, Theme } from '@material-ui/core'
import FilesRelatedToScan from './FilesRelatedToScan'
import SelectScanFromHierarchy from './SelectScanFromHierarchy'
import { SelectRoleHierarchyForScanExecution } from './SelectRoleHierarchyForScanExecution'
import { FileDetails } from '../../../../shared/src/data/fileDetails'

type ScanMetadataSelectionProps = {
  selectedScan?: ScanDetails
  setSelectedScan: (scan?: ScanDetails) => void
  isStepValid: (isValid: boolean) => void
  fileDetails?: FileDetails[]
  setFileDetails: (fileDetails?: FileDetails[]) => void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    selection: {
      padding: theme.spacing(1),
      display: 'flex',
      flexDirection: 'column',
    },
    files: {
      marginTop: theme.spacing(1),
    },
    alertContainer: {
      width: '100%',
    },
    loading: {
      marginTop: theme.spacing(1),
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  }),
)

export default function ScanMetadataSelection({
  selectedScan,
  setSelectedScan,
  isStepValid,
  setFileDetails,
  fileDetails,
}: ScanMetadataSelectionProps): JSX.Element {
  const [selectedRoleHierarchy, setSelectedRoleHierarchy] =
    useState<RoleHierarchy>()
  const classes = useStyles()

  useEffect(() => {
    setSelectedScan(undefined)
  }, [selectedRoleHierarchy, setSelectedScan])

  useEffect(() => {
    isStepValid(!!selectedScan && !!fileDetails?.length)
  }, [isStepValid, selectedScan, fileDetails])

  return (
    <Box className={classes.selection}>
      <SelectRoleHierarchyForScanExecution
        selectedRoleHierarchy={selectedRoleHierarchy}
        setSelectedRoleHierarchy={setSelectedRoleHierarchy}
      />
      <SelectScanFromHierarchy
        selectedRoleHierarchy={selectedRoleHierarchy}
        selectedScan={selectedScan}
        setSelectedScan={setSelectedScan}
        pending
      />
      <Box className={classes.files}>
        <FilesRelatedToScan
          scan={selectedScan}
          fileDetails={fileDetails}
          setFileDetails={setFileDetails}
        ></FilesRelatedToScan>
      </Box>
    </Box>
  )
}
